import { PropTypes } from 'react-desc';
import { QB_ADD_FILTER_METHOD_TYPES } from './components/helpers/types.js';

var props = {
  /** inpect props to component wrapper */
  containerProps: PropTypes.object.description('inject props to component wrapper'),

  /** add filter strategy */
  addFilterMethod: PropTypes.oneOf([QB_ADD_FILTER_METHOD_TYPES.APPEND, QB_ADD_FILTER_METHOD_TYPES.IN_PLACE]).description('add filter strategy'),

  /** group filter strategy */
  groupFilterMethod: PropTypes.oneOf([QB_ADD_FILTER_METHOD_TYPES.APPEND, QB_ADD_FILTER_METHOD_TYPES.IN_PLACE]).description('group filter strategy'),

  /** change callback */
  onChange: PropTypes.func.description('change callback'),

  /** fields to query */
  fields: PropTypes.arrayOf(PropTypes.shape({
    target: PropTypes.oneOf(['operator', 'field', 'value']),
    component: PropTypes.element,
    condition: PropTypes.arrayOf(PropTypes.shape({
      source: PropTypes.oneOf(['operator', 'field', 'value']),
      operator: PropTypes.oneOf(['checkNotEmpty', 'greaterThan', 'greaterThanOrEquals', 'lessThanOrEquals', 'startsWith', 'contains', 'validDate', 'equal', 'notEqual', 'isNull', 'isNotNull', 'isIn', 'isNotIn']),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }))
  })).description('fields to query'),

  /** fields actions */
  fieldsSharedActions: PropTypes.shape({
    onFieldChange: PropTypes.arrayOf(PropTypes.func),
    onOperatorChange: PropTypes.arrayOf(PropTypes.func),
    onValueChange: PropTypes.arrayOf(PropTypes.func)
  }).description('fields actions'),

  /** query builder format */
  format: PropTypes.string.description('query builder format'),

  /** initial values */
  init: PropTypes.shape({
    step: PropTypes.number,
    mapFilters: PropTypes.object,
    mapGroups: PropTypes.object,
    main: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object)
  }).description('initial values'),

  /** class for rule container */
  ruleContainerClassName: PropTypes.string.description('class for rule container'),

  /** handle field change */
  handleDrop: PropTypes.func.description('handle field change'),

  /** handle field change drop */
  handleDropFilter: PropTypes.func.description('handle field change drop'),

  /** handle field group change */
  handleDropGroup: PropTypes.func.description('handle field group change'),

  /** handle field change */
  handleFieldChange: PropTypes.func.description('handle field change'),

  /** handle rule container operator change */
  handleRuleContainerOperator: PropTypes.func.description('handle rule container operator change'),

  /** handle rule container grouping change */
  handleRuleContainerUnGroup: PropTypes.func.description('handle rule container grouping change'),

  /** filter add callback */
  onAddFilter: PropTypes.func.description('filter add callback'),

  /** rule container add callback */
  onAddRuleContainer: PropTypes.func.description('rule container add callback'),

  /** remove filter callback */
  onRemoveFilter: PropTypes.func.description('remove filter callback'),

  /** show output */
  displayOutput: PropTypes.bool.description('show output'),

  /** show output label */
  displayOutputLabel: PropTypes.shape({
    show: PropTypes.string,
    hide: PropTypes.string
  }).description('show output label'),

  /** one or multiple rows for query */
  singleRow: PropTypes.bool.description('one or multiple rows for query'),
  toolTipZIndex: PropTypes.number.description('ZIndex for action controls').defaultValue(110)
};

export { props };
//# sourceMappingURL=propTypes.js.map
